import { Component, OnInit } from '@angular/core';
import { SettingsService, SelectionSet } from '../settings.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-selection-options',
    templateUrl: './selection-options.component.html',
    styleUrls: ['./selection-options.component.scss'],
    standalone: false
})
export class SelectionOptionsComponent implements OnInit {
	// <General>
	private readonly _selectionSetIdQueryParamName = "id";
	private readonly _pageRelativePath = "settings/selection-options";
	// </General>

  public selectionSets: SelectionSet[] = [];

	private _selectedSelectionSet: SelectionSet;
	public get selectedSelectionSet(): SelectionSet {
		return this._selectedSelectionSet;
	}
	public set selectedSelectionSet(value: SelectionSet) {
		this._selectedSelectionSet = value;

		if (this._selectedSelectionSet) {
			this._location.replaceState(`${this._pageRelativePath}?${this._selectionSetIdQueryParamName}=${this._selectedSelectionSet.selectionSetId}`);
		} else {
			this._location.replaceState(this._pageRelativePath);
		}
	}

  constructor(
		private _settingsService: SettingsService,
		private _route: ActivatedRoute,
		private _location: Location,
	) { }

  ngOnInit() {
		const $this = this;

		this._settingsService.getSelections(0).subscribe(
			(response) => {
      	$this.selectionSets = response.selectionSets;

				$this._route.queryParamMap.subscribe(
					(queryParams) => {
						let id: number = +queryParams.get($this._selectionSetIdQueryParamName);

						if (id) {
							$this.selectedSelectionSet = this.selectionSets.find((selectionSet) => selectionSet.selectionSetId === id);
						}
					}
				);
    	}
		);
  }
}
